import { render, staticRenderFns } from "./teachingMaterial.vue?vue&type=template&id=8bd8595c&scoped=true"
import script from "./teachingMaterial.vue?vue&type=script&lang=js"
export * from "./teachingMaterial.vue?vue&type=script&lang=js"
import style0 from "./teachingMaterial.vue?vue&type=style&index=0&id=8bd8595c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd8595c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bd8595c')) {
      api.createRecord('8bd8595c', component.options)
    } else {
      api.reload('8bd8595c', component.options)
    }
    module.hot.accept("./teachingMaterial.vue?vue&type=template&id=8bd8595c&scoped=true", function () {
      api.rerender('8bd8595c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collegeEdition/teachingMaterial.vue"
export default component.exports